import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SlidingPanel } from 'core/components';
import { UpdatedAtSubtitle } from 'core/elements';
import { ProjectType } from 'projects/constants';
import { IProjectDetails } from 'projects/types';
import { Size } from 'theme/enums';

import { ExternalProjectCards } from './ExternalProjectCards';
import { BaseInformation } from './tabs';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  project: IProjectDetails;
}

export const ProjectDetailsDrawer = ({ isOpen, onClose, project }: IProps) => {
  const { t } = useTranslation();

  const isDtdProject = useMemo(() => {
    return project.type === ProjectType.DAY_TO_DAY;
  }, [project.type]);

  return (
    <SlidingPanel
      isOpen={isOpen}
      onClosePanel={onClose}
      title={t('titleProjectDetailsDrawer', { name: project.name })}
      subtitle={<UpdatedAtSubtitle updatedAt={project.updatedAt} />}
      extra={isOpen && <ExternalProjectCards project={project} />}
      size={isDtdProject ? Size.MD : Size.LG}
    >
      <BaseInformation project={project} />
    </SlidingPanel>
  );
};
